import type { BenefitGrantDto } from "./benefit-types"

/**
 * Unprocessed grants remain eligible for the correction dialog. With vendor instructions the
 * dialog is outcome-only; the API still rejects amount/date changes and any financial allocation.
 */
export function canCorrectDraftGrant(grant: BenefitGrantDto): boolean {
  return [0, 1].includes(grant.grantStatus) && !grant.certificationDate &&
    !grant.serviceProviderPayments.some(payment => payment.contractPayments.length > 0)
}
